import config from 'config'

import featureFlagConfig from './config'

export default function isFeatureEnabled(featureName) {
  const featureConfig = featureFlagConfig[featureName]

  if (!featureConfig) return false

  const isEnabledForEnv = featureConfig[config.env]
  const isEnabledByDefault = featureConfig.default

  return isEnabledForEnv !== undefined ? isEnabledForEnv : isEnabledByDefault
}
